import {initialStoreObject} from "./store";
import SimpleCollectionStore from "./SimpleCollectionStore";

export default class OccurrenceRulesStore extends SimpleCollectionStore {

    init() {
        this.data = initialStoreObject;
    }

    doFetch(parameters, afterLoadCallback) {
        this.fetch(
            this.data,
            "api/occurrencerule/get.php",
            {},
            afterLoadCallback
        );
    }

}